import { SafeResourceUrl } from '@angular/platform-browser';

export class ImageDataInfo {
  Url: string;
  SafeUrl: SafeResourceUrl;
  Width: number;
  Height: number;
}
